import { render, staticRenderFns } from "./CustomerAddressForm.vue?vue&type=template&id=aa6b55d8"
import script from "./CustomerAddressForm.vue?vue&type=script&lang=js"
export * from "./CustomerAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports